// @flow

import { $set, update } from 'qim';

import ActionTypes from 'app/settings/ActionTypes';
import { createReducer } from 'app/common/utils/ReduxUtils';

const initialState = {
  confirmingDataDeletion: false,
};

const handlers = {
  [ActionTypes.PROMPT_TO_CONFIRM_DATA_DELETION](state) {
    return update(['confirmingDataDeletion', $set(true)], state);
  },

  [ActionTypes.DISMISS_DATA_DELETION_CONFIRMATION](state) {
    return update(['confirmingDataDeletion', $set(false)], state);
  },

  [ActionTypes.CANCEL_DATA_DELETION](state) {
    return update(['confirmingDataDeletion', $set(false)], state);
  },
};

export default createReducer(handlers, initialState);
